import React, { Component } from 'react'
import { ReactComponent as Logo } from './logo.svg'

import styles from './styles.module.scss'

class Header extends Component {
  render() {
    return (
      <header>
        <Logo className={styles.logo} />
      </header>
    )
  }
}

export default Header
